var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile"},[_c('v-row',[_c('v-col',{attrs:{"cols":"10","offset":"1"}},[_c('p',{staticClass:"text-h3 text-center"},[_vm._v("Sorry, Expericoder is not available on mobile devices.")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }